import { parseTemplate, transformOrigin, filterTitle } from '../util/helpers.js';
import { opts } from '../opts.js';

import { hits } from '../../../../../dist/vendor/instantsearch.js/es/widgets/index.js';
// import { highlight } from '../../../../dist/vendor/instantsearch.js/es/helpers/components/Highlight.js';
const { cssClasses, imageSize } = opts.hits;

const TAG_PLACEHOLDER_IMAGE = '<img src="/wp-content/themes/emc/assets/img/emc-placeholder.png" alt="image placeholder">';

const terms = ( taxonomies ) => {
	let termLink;

	// if (!taxonomies) {
	return [];
	// }

	// return Object.keys(taxonomies)
	// 	.map(tax => {
	// 		termLink = new URL(tax, window.location.origin);
	// 		return taxonomies[tax];
	// 	})
	// 	.map(taxonomyTerms => taxonomyTerms.map(term => `
	// 		<span class="pill">${term}</span>
	// 	`).join('')).join('');
};

const image = ( { images, post_title } ) => {
	if ( ! images ) {
		return TAG_PLACEHOLDER_IMAGE;
	}
	const src = images[ imageSize ]?.url;

	return src
		? `<img src="${ transformOrigin( images[ imageSize ].url ) }" alt="${ post_title }"/>`
		: TAG_PLACEHOLDER_IMAGE
};

const searchPageResult = ( hit ) => parseTemplate( 'card', hit );
const transformHit = ( hit ) => {
	const { _highlightResult } = hit;
	Object.entries( _highlightResult ).forEach( ( entry ) => {
		if ( entry[ 1 ]?.value && hit[ entry[ 0 ] ] ) {
			hit[ entry[ 0 ] ] = entry[ 1 ]?.value;
		}
	} );

	if (!hit.permalink) {
		return hit;
	}

	const permalink = transformOrigin( hit.permalink );
	const category = hit.taxonomies?.category ?? [];

	return {
		...hit,
		permalink,
		post_type_label: filterTitle( hit.post_type_label ),
		image: image( hit ),
		category,
		// post_date: hit.post_date,
		terms: terms( hit.taxonomies ) ?? [],
	};
};

export const config = {
	...opts.hits,
	templates: {
		item( item, { html, components, sendEvent } ) {
			return searchPageResult( transformHit( item ) );
		},
		empty( results, { html } ) {
			return html` <div class="${ cssClasses.noResults }">
				<h3>Uh oh...</h3>
				<p>No results for <q>${ results.query }</q></p>
			</div>`;
		},
	},
};

export const widget = hits;
